import React from 'react';
import Products from './components/Products';
import Cart from './components/Cart';
import './styles/components/store.scss';
import ProductDisplay from './components/ProductDisplay'
import WhoWeServe from './components/WhoWeServe'

// Default state for the component
const defaultState = {
  shopOpen: true,
  firstInteracted: false,
  isCartOpen: false,
  checkout: { lineItems: [] },
  products: [
    {
      title:'Military',
      handle:'Military',
      image:'/images/WhoWeServe/Military.webp',
      description:'Focus on your mission while we handle your supply needs. We provide access to tactical gear, construction services, and even challenge coins.'
    },
    {
      title:'PublicSector',
      handle:'Federal Agencies',
      image:'/images/WhoWeServe/Federal.webp',
      description: 'We serve diverse federal agencies like DOJ, military, FAA, FBI, NIH, and HUD. We streamline purchasing and adapt to your agency\'s specific needs.'    
    },    
    {
      title:'PublicSector',
      handle:'Public Sector',
      image:'/images/WhoWeServe/StateAndLocal.webp',
      description: 'From body cams to printers, we offer custom solutions for law enforcement, courthouses, municipal offices, and more.'    
    },
    {
      title:'Education',
      handle:'K-12 and Higher Ed',
      image:'/images/WhoWeServe/Education.webp',
      description:'Empowering education with diverse supplies such as interactive projectors, sports equipment, and janitorial essentials.'
    },
    {
      title:'SystemsIntegrators',
      handle:'Systems Integrators',
      image:'/images/WhoWeServe/SystemsIntegrators.webp',
      description: 'Expert solutions for Wi-Fi, security, internet, fiber optics, backup power, and servers. We support legacy systems and source hard-to-find parts.'    
    },
    {
      title:'Health Research',
      handle:'Research Centers',
      image:'/images/WhoWeServe/HealthAndResearch.webp',
      description:'Providing the latest in hazard protection and lab equipment to support groundbreaking discoveries.'
    },
    {
      title:'SystemsIntegrators',
      handle:'Systems Integrators',
      image:'/images/WhoWeServe/SystemsIntegrators.webp',
      description:'Expert solutions for Wi-Fi, security, internet, fiber optics, backup power, and servers. We support legacy systems and source hard-to-find parts.'
    }
  ],
  shop: {}
};

export default class Store extends React.Component {
  constructor(props) {
    super(props);
    this.state = defaultState;
  }

  render() {
    let modalContainerClass = (this.state.shopOpen ? 'one' : 'one out');
    if(!this.state.firstInteracted)
      modalContainerClass = 'one'
    
    return (
      <>
        <div id="modal-container" className={modalContainerClass}>
          <div className={'modal-background'}>
            <div className={"modal"}>
              {/*Shop*/}
              <div className="App Store">
                <WhoWeServe products={this.state.products} />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

